(function () {
    'use strict';

    angular
        .module('admin')
        .controller('PartnerUserFormController', PartnerUserFormController);

    PartnerUserFormController.$inject = ['$state', '$stateParams', 'ManagePartnersService'];

    function PartnerUserFormController($state, $stateParams, ManagePartnersService) {
        var vm = this;
            vm.name                 = '';
            vm.email                = '';
            vm.password             = '';
            vm.function             = '';
            vm.shortDescription     = '';
            vm.socialSkype          = '';
            vm.socialFacebook       = '';
            vm.socialTwitter        = '';
            vm.socialLinkedin       = '';
            vm.socialGooglePlus     = '';
            vm.phone                = '';
            vm.submit               = submit;

        function activate() {
        }

        function submit () {
            vm.fields = {
                name                : vm.name,
                email               : vm.email,
                password            : vm.password,
                function            : vm.function,
                shortDescription    : vm.shortDescription,
                socialSkype         : vm.socialSkype,
                socialFacebook      : vm.socialFacebook,
                socialTwitter       : vm.socialTwitter,
                socialLinkedin      : vm.socialLinkedin,
                socialGooglePlus    : vm.socialGooglePlus,
                phone               : vm.phone
            };

            ManagePartnersService.storePartnerUser(vm.fields).then(function(response){
                if (response.errors) {
                    vm.formErrors = response.errors;
                } else {
                    $state.go('root.partners.users');
                }
            });
        }
        activate();
    }

})();